// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__3Z1BQ","magazine-row":"styles-m__magazine-row__4eQHu","stretch":"styles-m__stretch__Sxz22","main-container":"styles-m__main-container__3e2MU"};